import { Stack } from '@mui/material';
import Typography from '../../../../components/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import OrderGridSettings from '../../components/OrderGridSettings';

interface IAcceptSuggestionOrderContentProps {
  onChangeInsertGridMultiplier: (value: number, maintainOriginalParts: boolean) => void;
}
export const AcceptSuggestionOrderContent = ({
  onChangeInsertGridMultiplier,
}: IAcceptSuggestionOrderContentProps) => {
  const { translate } = useTranslation();

  return (
    <Stack
      style={{ minHeight: 'calc(8.5rem + 1.25rem)', flexGrow: 1 }}
      sx={{
        padding: 2,
        paddingBottom: 0,
        gap: 3,
      }}
    >
      <Typography color="textPrimary">
        {translate(LangEnum.SUGGESTED_ORDER_ACCEPT_ARCHIVE_CREATE_FINALIZE)}
      </Typography>
      <OrderGridSettings onChangeInsertGridMultiplier={onChangeInsertGridMultiplier} />
    </Stack>
  );
};
